export const categoryLabel = {
  overbook: 'Overbook',
  check_in: 'Check in',
  check_in_overbook: 'CI/OB',
  no_show: 'No show',
  induction: 'Induction',
}

// Differentiates an `overbook` shift by how the overbooking was created.
// Falls back to the generic `categoryLabel.overbook` when the status is null/absent.
export const overbookStatusLabel = {
  system: 'Overbook (Auto)',
  system_modified: 'Overbook (Auto, overridden)',
  manual: 'Overbook (Manual)',
}

export const OFFER_TO_FLEX_ALL = 'all'
export const OFFER_TO_FLEX_NETWORK = 'network'
export const OFFER_TO_FLEX_INDIVIDUAL = 'individual'
export const OFFER_TO_FLEX_AGENCY = 'agency'
export const OFFER_TO_FLEX_ALL_FILL_AUTOMATION = 'all_fill_automation'
export const OFFER_TO_FLEX_NETWORK_FILL_AUTOMATION = 'network_fill_automation'
export const SYMBOL_OFFER_TO_FLEX_ALL = 'A'
export const SYMBOL_OFFER_TO_FLEX_NETWORK = 'S'
export const SYMBOL_OFFER_TO_FLEX_INDIVIDUAL = 'I'
export const SYMBOL_OFFER_TO_FLEX_AGENCY = 'AG'
export const SYMBOL_OFFER_TO_FLEX_ALL_FILL_AUTOMATION = 'A (Auto)'
export const SYMBOL_OFFER_TO_FLEX_NETWORK_FILL_AUTOMATION = 'S (Auto)'
